import { RingRepository } from '../../domain/repository';
import { RingRepositoryImpl } from '../repository';

export const ringProviders = [
  {
    provide: RingRepository,
    useExisting: RingRepositoryImpl,
  },
];


